import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { initiateUserStripeConnect } from "../../redux/actions/stripeActions";
import { DASHBOARD_STACK } from "../../utils/screenNames";

/**
 * Stripe redirects users here when their onboarding link expires before
 * completion. We immediately request a fresh link and redirect them back
 * into Stripe's hosted onboarding.
 */
const StripeConnectRefresh = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const refresh = async () => {
      try {
        const origin = window.location.origin;
        const refreshURL = `${origin}${DASHBOARD_STACK.STRIPE_CONNECT_REFRESH}`;
        const returnURL = `${origin}${DASHBOARD_STACK.STRIPE_CONNECT_RETURN}`;
        const data = await initiateUserStripeConnect({ refreshURL, returnURL });
        if (!data?.url) {
          throw new Error("No onboarding URL returned");
        }
        window.location.href = data.url;
      } catch (err) {
        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Could not refresh Stripe onboarding link."
        );
        setTimeout(() => navigate(DASHBOARD_STACK.PAYMENTS), 2500);
      }
    };

    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-[#000F1F] text-[#FEFCEB] min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-[400px]">
        {error ? (
          <>
            <h2 className="text-[20px] font-medium mb-2">Couldn't reconnect to Stripe</h2>
            <p className="text-app-text-secondary text-[14px]">{error}</p>
          </>
        ) : (
          <>
            <h2 className="text-[20px] font-medium mb-2">Refreshing your Stripe link...</h2>
            <p className="text-app-text-secondary text-[14px]">
              We'll send you back to Stripe in a moment.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default StripeConnectRefresh;
